<template>
    <MainContent title="Listado de mensajes">
        <template v-slot:header>
            <h3 class="card-title" my-3></h3>
            <div class="card-tools mb-2 pb-1">
                <router-link :to="{ name: 'back.mensajes.crear' }" class="btn btn-dark d-block d-md-inline">
                    CREAR INCIDENCIA
                </router-link>
            </div>
        </template>

        <template v-slot:content>
            <div class="row align-items-center mb-4">
                <div class="col-12 col-lg-4 margin-bottom-mobile pt-1">
                    <SearchComponent v-model="search"/>
                </div>

                <div class="col-12 col-lg-2 ml-auto">
                    <multiselect v-model="selectEstado" :options="estados" track-by="name" label="name" id="estado" :show-labels="false" placeholder="Estado">
                        <template slot="noResult">No existe ese estado.</template>
                    </multiselect>
                </div>
            </div>

            <div class="cont_msjs">
                <b-table v-if="incidencias" striped hover :items="incidencias.data" :fields="fields">
                    <template #cell(respondido)="data" >
                        {{data.item.estado.id == 3 ? "No" : "YES"}}
                    </template>
                    <template #cell(id)="data">
                        <OpcionesDropdownComponent v-bind:options="[{ to: { name: 'back.mensajes.show', params: { incidencia_id: data.value}}, label: 'Ver'}]"/>
                    </template>
                </b-table>
            </div>
            
            <div class="row mt-5" v-if="!loading && incidencias">
                <div class="col-12 col-lg-3">
                    <ElementosPorPaginaComponent v-model="per_page"/>
                </div>
                <div class="col-12 col-lg-4">
                    <PaginateComponent :current_page="incidencias.meta.current_page" :last_page="incidencias.meta.last_page" v-on:change_page="setPage"/>
                </div>
            </div> 
        </template>
    </MainContent>
</template>


<script>
    import MainContent from "../../../components/backend/components/MainContent";
    import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";
    import SearchComponent from "@/components/backend/components/SearchComponent";
    import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
    import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';

    export default {
        data() {
            return {
                fields: [
                    {
                        key: "asunto",
                        sortable: false,
                    },
                    {
                        key: "estado.name",
                        label: 'estado',
                        sortable: false,
                    },
                    {
                        key: "prioridad.name",
                        label: 'Prioridad',
                        sortable: false,
                    },
                    {
                        key: "respondido",
                        label: 'Respondido',
                        sortable: false,
                    },
                    {
                        key: 'id',
                        label: 'opciones',
                        class: 'text-center'
                    }
                ],
                incidencias: null,
                estados: [],
                selectEstado: null,
                loading: false,
                search: '',
                per_page: 5,
                page: 1,
            }
        },
        created() {
            this.getEstados();
            this.getIncidencias();
        },
        methods: {
            getIncidencias() {
                this.loading = true;
                const params = {
                    filters: {
                        per_page: this.per_page ?? 5,
                        page: this.page,
                        search: this.search ?? '',
                    },
                };

                if (this.selectEstado) {
                    params.filters.estado = this.selectEstado.id
                }


                this.$store.dispatch(this.config.getVuexAlias('back.mensajeria.index'), params).then(res => {
                    this.incidencias = res.data;
                })

                this.loading = false;
            },
            getEstados() {
                const params = {
                    filters: {}
                };
                this.$store.dispatch(this.config.getVuexAlias('back.mensajeria.estados'), params).then(res => {
                    this.estados = res.data.data;
                });
            },
            setPage(page) {
                this.page = page;
                console.log(page);
                this.getIncidencias();
            },
        },
        watch: {
            per_page() {
                this.getIncidencias();
            },
            selectEstado() {
                this.page = 1;
                this.getIncidencias();
            },
            search() {
                setTimeout(() => {
                    this.getIncidencias();
                }, 200)

            }
        },
        components: {
            MainContent, OpcionesDropdownComponent, SearchComponent, ElementosPorPaginaComponent, PaginateComponent
        }
    }
</script>

<style scoped>
    @media (max-width: 768px) {
        .cont_msjs {
            overflow: scroll;
        }
        .margin-bottom-mobile {
            margin-bottom: 2rem;
        }        
        table {
            font-size: 5px;
        }
    }
</style>